import { BopsLogo } from '@Assets';

const MotifHaloOrbit = () => (
  <div className="relative w-[180px] h-[180px] flex items-center justify-center">
    {/* Breathing rings */}
    <div
      className="absolute inset-[30px] rounded-full animate-halo-orbit-breathe"
      style={{ border: '1.5px solid rgba(124,108,246,0.55)' }}
    />
    <div
      className="absolute inset-[10px] rounded-full animate-halo-orbit-breathe-delayed"
      style={{ border: '1.5px solid rgba(124,108,246,0.40)' }}
    />
    <div
      className="absolute -inset-[15px] rounded-full animate-halo-orbit-breathe-delayed-2"
      style={{ border: '1.5px solid rgba(124,108,246,0.28)' }}
    />

    {/* Sweep glow */}
    <div
      className="absolute w-[88px] h-[88px] rounded-full z-[1] animate-halo-orbit-sweep"
      style={{ boxShadow: '22px 0 28px -2px rgba(124,108,246,0.45)' }}
    />

    {/* Orbits */}
    <div className="absolute -inset-[8px] rounded-full animate-halo-orbit-cw">
      <div
        className="absolute -top-[4.5px] left-1/2 -translate-x-1/2 w-[9px] h-[9px] rounded-full"
        style={{ background: '#7c6cf6', boxShadow: '0 0 10px rgba(124,108,246,0.7)' }}
      />
    </div>
    <div className="absolute inset-[28px] rounded-full animate-halo-orbit-ccw">
      <div
        className="absolute -top-[3px] left-1/2 -translate-x-1/2 w-[6px] h-[6px] rounded-full"
        style={{ background: '#a89cf9', boxShadow: '0 0 6px rgba(168,156,249,0.6)' }}
      />
    </div>

    {/* Center mark */}
    <div className="relative z-[2] w-[88px] h-[88px] rounded-full bg-white border border-gray-200 shadow-[0_8px_24px_rgba(16,24,40,0.08)] flex items-center justify-center">
      <BopsLogo className="h-11" />
    </div>
  </div>
);

export default MotifHaloOrbit;
